import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GENERATE_UPDATE_DELIVERY_URL, TRACK_GEN_NEW_DELIVERY_SHIPMENT_URL_ENCRYPT, TRACK_GEN_NEW_SAVE_INSTRUCTION_URL_ENCRYPT, GENERATE_SHIPMENT_DELIVERY_URL } from '../config/app-settings.config';
import { EncrDecrService } from './encr-decr-service.service';
import appTackDetailMock from '../../assets/mocks/appStatus.json';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrackCardDeliveryService {
  tokenVal = window['authenticationDetails']['EapplyTokenGenerationResponse']['tokenGenerationResponse']['access_token'] || sessionStorage.getItem('jwt');
  constructor(private http: HttpClient, private encryptDecService: EncrDecrService) { }

  trackShippmentDelivery(requestBody) {
    let httpOptions : any;
    httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + sessionStorage.getItem('jwt_new'),
        // Authorization: 'Bearer ' + this.tokenVal,
        withCredentials: 'true',
        'Content-Type': 'application/json',
        Cookie: sessionStorage.getItem('cookie_new')
      }),
      responseType : 'text'
    };
    requestBody = TRACK_GEN_NEW_DELIVERY_SHIPMENT_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${GENERATE_SHIPMENT_DELIVERY_URL}`, requestBody, httpOptions);
    // return of(appTackDetailMock); 
  }

  sendTrackedInstructions(requestBody) {
    let httpOptions : any;
      httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + sessionStorage.getItem('jwt_new'),
        // Authorization: 'Bearer ' + this.tokenVal,
        withCredentials: 'true',
        'Content-Type': 'application/json',
        Cookie: sessionStorage.getItem('cookie_new')
      }),
      responseType : 'text'
    };

    requestBody = TRACK_GEN_NEW_SAVE_INSTRUCTION_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${GENERATE_UPDATE_DELIVERY_URL}`, requestBody, httpOptions);
  }

}
